export default __webpack_public_path__ + "static/media/logo.3ae59d2d.png";